module.exports = __webpack_public_path__ + "static/media/secondflooronly.d35f7ebb.png";